import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { college } from '@app/_models/college';
import { YearOfPassing } from '@app/_models/yearOfPassing';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class YearOfPassingService {
  url: string;
  constructor(private http: HttpClient) { }

  getYears() {
    var temp = this.http.get<any>(`${environment.apiUrl}/yearOfPassing/getYearList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  

  addYear(yearParam: YearOfPassing): Observable<YearOfPassing> {
    return this.http.post<YearOfPassing>(`${environment.apiUrl}/yearOfPassing/addYear`,yearParam, httpOptions).pipe( );
  }

  updateYear(YearParam: YearOfPassing): Observable<YearOfPassing> {
    return this.http.post<YearOfPassing>(`${environment.apiUrl}/yearOfPassing/updateYearById`,YearParam, httpOptions).pipe( );
  }

  deleteYear(id) {
    return this.http.delete<YearOfPassing>(`${environment.apiUrl}/yearOfPassing/deleteYearById/`+id, httpOptions).pipe( );
  }

  geMonths() {
    return this.http.get<any>(`${environment.apiUrl}/monthofpassing/getMonthList`,httpOptions);
  }

}